import { memo } from "react";

import Container from "@mui/material/Container";
import PropTypes from "prop-types";

function Page({ maxWidth = false, children, fabBar = false, fullscreen = false, sx, ...props }) {
  return (
    <Container
      maxWidth={maxWidth}
      sx={[
        {
          pt: fullscreen ? 8 : 9,
          pb: fullscreen ? 0 : fabBar ? 8.5 : 2,
          paddingLeft: "16px !important",
          paddingRight: "16px !important",
          overflowX: "auto",
          height: "100dvh",
          scrollBehavior: "smooth",
        },
        !maxWidth && {
          maxWidth: "100%",
          px: "0 !important",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...props}
    >
      {children}
    </Container>
  );
}

Page.propTypes = {
  sx: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  fullscreen: PropTypes.bool,
  fabBar: PropTypes.bool,
  children: PropTypes.node,
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default memo(Page);
